import React from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from '../../../assets/languages/index.js';
import Attachments from "../../../components/features/Attachments.jsx";
import Addresses from "../../../components/features/Addresses.jsx";
import Phone from "../../../components/features/Phone.jsx";
import Select from 'react-select';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from "../../../services/axios.js";
import {config} from "../../../services/config.js";
import { Toastify } from '../../../components/utils/index.js';
import { CheckNationalCode } from '../../../components/utils/validation.js';
import Modal from '../../../components/features/Modal.jsx';


const CreateAccounts = () => {
	const preferences = useSelector((state) => state.preferences);
	const [name, SetName] = useState('');
	const [firstName, SetFirstName] = useState('');
	const [lastname, SetLastName] = useState('');
	const [nationalCode, SetNationalCode] = useState("");
	const [phone, SetPhoneNumber] = useState([]);
	const [email, SetEmail] = useState('');
	const [ecoCode, SetEcoCode] = useState('');
	const [addresses, SetAddress] = useState([]);
	const [accountType, SetAccountType] = useState('Individual');
	const [salutationType, SetSalutationType] = useState('Mr.');
	const language = LanguageLoader(preferences.language);
	const [searchParams] = useSearchParams();
	const [showModal, setShowModal] = useState(false);
	const [hideModal, setFallDownModal] = useState(false);
	const [dataEntry, SetDataEntry] = useState([]);
	const [showSaveButton, setSaveButton] = useState(true);
	const [triggerPhoneDuplicate, setTriggerPhoneDuplicate] = useState(false);
	const [attachments, SetAttachment] = useState([]);
	const [selectedEntryId, setSelectedEntryId] = useState(undefined);
	const navigate = useNavigate();

	const [disabledFields, setDisabledFields] = useState({
		firstName: false,
		lastName: false,
		nationalCode: false,
		email: false,
		salutationType:false,
		accountType:false
	});
	const id = searchParams.get("id");
	const BackTo = searchParams.get("BackTo");
	const backSerial = searchParams.get("serial");
	useEffect(() => {
		if (id){
			FetchAccountById(id);
			FetchAddressAndBranch(id);
		}
		// If serial is passed, we could prefill something here if needed
	}, [searchParams]);

	const FetchAccountById = async (id) => {
		try {
			const method = 'Retrieve';
			const data = {
				id:id,
				selected_fields: [ "id", "name", "type", "salutation", "first_name", "last_name", "account_type", "emails", "numbers", "national_number", "attachments","tax_id_number"],
				module : 'Accounts',
			};
			const APIResponse = await api.post(
				config.api + '?method=' + method,
				JSON.stringify(data)
			);
			if (APIResponse) {
				const item = APIResponse[0];
				SetFirstName(item.first_name || "");
				SetLastName(item.last_name || "");
				SetEmail(item.emails?.[0]?.email_address || "");
				SetNationalCode(item.national_number || "");
				SetSalutationType(item.salutation || "Mr.");
				SetPhoneNumber(item.numbers || []);
				SetAccountType(item.type || "Individual");
				SetEcoCode(item.tax_id_number || "");
				SetName(item.name || "");
				SetAttachment(item.attachments || []);
				SetDataEntry([item]);
				setSelectedEntryId(item.id);
				setDisabledFields({
					firstName: !!item.first_name,
					lastName: !!item.last_name,
					nationalCode: !!item.national_number,
					email: !!item.emails,
					salutationType: !!item.salutation,
					accountType: !!item.type,
					ecoCode : !!item.tax_id_number,
					name: !!item.name,
				});
			}
		} catch (error) {
			Toastify("خطا در دریافت اطلاعات");
		}
	};

	const FetchAddressAndBranch = async (id) => {
		try {
			const method = 'FetchAddressAndBranch';
			const data = { id };
			const APIResponse = await api.post(
				config.api + '?method=' + method,
				JSON.stringify(data)
			);
			if (APIResponse) {
				SetAddress(APIResponse.addresses || []);
			}
		} catch (error) {
			Toastify("خطا در دریافت آدرس");
		}
	};
	
	const DoSave = async () => {
		let finalAddresses = addresses;
		let finalNumbers = phone;
		
		if (selectedEntryId) 
		{
			finalAddresses = addresses.filter(address => !address.id || address.id.trim() === "");
			finalNumbers = phone.filter(phone => !phone.id || phone.id.trim() === "");
		}
	
		const data = {
			id: selectedEntryId || undefined,
			first_name: firstName,
			last_name: lastname,
			name: name,
			type: accountType,
			national_number: nationalCode,
			addresses: finalAddresses,
			numbers: finalNumbers,
			email: email,
			salutationType: salutationType,
			ecoCode: ecoCode,
			attachments: attachments,
		};
		if ((!firstName && !name) || !addresses || addresses.length === 0)
		{
			Toastify('آدرس و نام الزامی است');
			return;
		}
		const method = 'CreateAccount';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		if (BackTo === 'CreateWork_Orders') 
		{
			const params = new URLSearchParams();
			if (backSerial) { params.set('serial', backSerial); }
			const primaryPhone = (Array.isArray(phone) && phone.length > 0 && phone[0]?.number) ? String(phone[0].number).replace(/\D/g, '') : '';
			if (primaryPhone) { params.set('phone', primaryPhone); }
			const qs = params.toString();
			navigate(`/dynamic/CreateWork_Orders${qs ? `?${qs}` : ''}`);
		}
		else if (APIResponse.result == true) 
		{
			navigate(`/detail/Accounts/${APIResponse.id}`);
		}
	};

	const FillInputes = async (index) => {
		setFallDownModal(true);
		if (dataEntry.length > 0 && index < dataEntry.length) {
			const item = dataEntry[index];
			setSelectedEntryId(item.id);
			SetFirstName(item.first_name);
			SetLastName(item.last_name);
			SetEmail(item.email);
			SetNationalCode(item.national_number);
			SetSalutationType(item.salutation);
			SetPhoneNumber(item.numbers);
			SetAccountType(item.accountType);
			SetEcoCode(item.tax_id_number);
			SetName(item.name);
			SetAddress(item.addresses || []);
			setDisabledFields({
				firstName: !!item.first_name,
				lastName: !!item.last_name,
				nationalCode: item.national_number ? true : false,
				email: !!item.email,
				salutationType: !!item.salutation,
				accountType: !!item.accountType,
				ecoCode : !!item.tax_id_number,
				name: !!item.name
			});
		}
	};
	
	const attachmentDrop = {
		image: 'فایل ضمیمه',
	}; 

	const DuplicateNationalCode = async (value) => {
		const data = {
			nationalCode: value
		};
		const method = 'DuplicateNationalCode';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		if (APIResponse.result == true) 
		{
			const entries = Array.isArray(APIResponse.data) ? APIResponse.data : [APIResponse.data];
			SetDataEntry(entries);
			setShowModal(true);
		}
		setTriggerPhoneDuplicate(true);
	};

	const handlePhoneChange = async (values) => {
		if(triggerPhoneDuplicate == false && !id)
		{		
			if (values.length > 0) 
			{
				const phoneNumber = values[0].number.replace(/\D/g, '');
				setSaveButton(false);
				await DuplicatePhoneNumber(phoneNumber);
			}
		}
		SetPhoneNumber(values);
	};

	const DuplicatePhoneNumber = async (phoneNumber) => {
		const data = {
			phoneNumber: phoneNumber
		};
		const method = 'DuplicatePhoneNumber';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		if (APIResponse.result == true)
		{
			const entries = Array.isArray(APIResponse.data) ? APIResponse.data : [APIResponse.data];
			SetDataEntry(entries);
			setShowModal(true);
		}
		setSaveButton(true);
		setTriggerPhoneDuplicate(true);
	};

	const HandleAttachment = (value) => {
		SetAttachment(value);
	};

	const HandleAddress = (value) => {
		SetAddress(value);
	};

	const handleModalClose = () => {
		setShowModal(false);
		if(!selectedEntryId){
			SetNationalCode('');
			SetPhoneNumber('');
		}
	};
	
	return <>
		<div className='title flex justify-between w-full'>
			<h6>ایجاد مشتری</h6>
			<div className="flex">
			<button onClick={DoSave} type="button" className={`btn ${showSaveButton ? 'btn-primary' : 'btn-secondary'}`} disabled={!showSaveButton} >
				{language.SAVE}
			</button>
			</div>
		</div>
		<div className="flex flex-wrap">
			<div className="Field_Container">
				<div className="flex">
					<label>
						نوع <span className="text-danger">*</span>
					</label>
				</div>
				<Select
					options={[
						{ value: 'Corporate', label: 'حقوقی' },
						{ value: 'Individual', label: 'حقیقی' },
					]}
					inputId="type-select"
					className="vision-select-container"
					classNamePrefix="vision-select"
					value={{ value: accountType, label: accountType === "Individual" ? "حقیقی" : "حقوقی" }}
					onChange={(selectedOption) => SetAccountType(selectedOption.value)}
					isDisabled={disabledFields.accountType}
				/>
			</div>
			{accountType === "Corporate" && (
				<> {/* React Fragment to group multiple elements */}
					<div className="Field_Container">
						<div className="flex">
							<label>
								نام <span className="text-danger">*</span>
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => SetName(e.target.value)}
							value={name}
							disabled={disabledFields.name}
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								کد اقتصادی <span className="text-danger">*</span>
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => SetEcoCode(e.target.value)}
							value={ecoCode}
							disabled={disabledFields.ecoCode}
						/>
					</div>
				</>
			)}
			{accountType === "Individual" && (
				<> {/* React Fragment to wrap multiple elements */}
					<div className="Field_Container">
						<div className="flex">
							<label>
								نام <span className="text-danger">*</span>
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => {
								const value = e.target.value;
								// Only allow alphabetic characters (Persian and English letters)
								if (/^[a-zA-Zآ-ی\s]*$/.test(value)) {
									SetFirstName(value);
								}
							}}
							value={firstName}
							disabled={disabledFields.firstName}
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								عنوان
							</label>
						</div>
						<Select
							options={[
								{ value: 'Miss.', label: 'خانم' },
								{ value: 'Mr.', label: 'آقای' },
							]}
							inputId="type-select"
							className="vision-select-container"
							classNamePrefix="vision-select"
							value={{ value: salutationType, label: salutationType === "Mr." ? "آقای" : "خانم" }}
							onChange={(selectedOption) => SetSalutationType(selectedOption.value)}
							isDisabled={disabledFields.salutationType}
						/>
					</div>

					<div className="Field_Container">
						<div className="flex">
							<label>خانوادگی <span className="text-danger">*</span></label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => {
								const value = e.target.value;
								// Only allow alphabetic characters (Persian and English letters)
								if (/^[a-zA-Zآ-ی\s]*$/.test(value)) {
									SetLastName(value);
								}
							}}
							disabled={disabledFields.lastName}
							value={lastname}
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>کدملی <span className="text-danger">*</span></label>
						</div>
						<input
							type="text"
							className="form-control"
							maxLength="10"
							value={nationalCode}
							onChange={(e) => {
								const value = e.target.value;
								if (/^\d{0,10}$/.test(value)) {
									SetNationalCode(value);
									if (value.length === 10) {
										// Validate Persian national code pattern
										if (!CheckNationalCode(value, accountType)) 
										{
											Toastify("لطفا کد ملی صحیح وارد کنید");
											return;
										}
										DuplicateNationalCode(value);
									}
								}
							}}
							disabled={disabledFields.nationalCode}
						/>
					</div>
				</>
			)}
			<div className="Field_Container">
				<div className="flex">
					<label>ایمیل</label>
				</div>
				<input type="text" className="form-control" 
					onChange={(e) => SetEmail(e.target.value)}
					disabled={disabledFields.email}
					value={email}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>آدرس<span className="text-danger">*</span></label>
				</div>
				<Addresses
					onChange={(value) => HandleAddress(value)}
					defaultValue={addresses}
				></Addresses>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>شماره همراه <span className="text-danger">*</span></label>
				</div>
				<Phone
					onBlur={(numbers) => {handlePhoneChange(numbers);}}
					defaultValue={phone}
				></Phone>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>ضمیمه</label>
				</div>
				<Attachments types={attachmentDrop} single={false} onChange={(value) => HandleAttachment(value)}></Attachments>
			</div>
			<Modal 
				handler={<></>} 
				trigger={showModal}
				fallDown={hideModal}
				onClose={handleModalClose}
				title="اطلاعات ثبت شده"
				>
				<div>
					{dataEntry.length > 0 ? (
						<table className="w-full border border-gray-300">
						<thead>
							<tr className="bg-gray-200">
								<th className="border p-2">شماره تماس</th>
								<th className="border p-2">نام</th>
								<th className="border p-2">عملیات</th>
							</tr>
						</thead>
						<tbody>
						{dataEntry.map((item, index) => (
							<tr key={item.id} className="border">
							<td className="border p-2">{item.phone_number}</td>
							<td className="border p-2">{item.name}</td>
							<td className="border p-2">
								<button onClick={() => FillInputes(index)} className="btn-primary">
									انتخاب
								</button>
							</td>
							</tr>
							))}
						</tbody>
						</table>
					) : null}
				</div>
			</Modal>
		</div>
	</>
}

export default CreateAccounts;